import {customAlphabet} from 'nanoid';

const nanoid = customAlphabet('abcdefghijklmnopqrstuvwxyz', 10)
export function randomString(size: number = 10){
    return nanoid(size)
}

export function dataURLtoBlob(dataUrl: string): Blob {
    const arr = dataUrl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
async function getWidthHeight(imageUri: string): Promise<{width: number, height: number}>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = function() {
            resolve({
                //@ts-expect-error this can be undefined
                width: this.width,
                //@ts-expect-error this can be undefined
                height: this.height,
            })
        }
        img.onerror = ()=>resolve({
            width: 0,
            height: 0
        })
        img.onerror = reject;
        img.src = imageUri
    })
}
function getImageThumbnail(file: File): Promise<{uri: string, width: number,height: number}>{
    return new Promise((resolve)=>{
        const reader = new FileReader();
        reader.onload = async (e) => {
            const uri = e.target.result as string;
            const {width, height} = await getWidthHeight(uri);
            resolve({uri, width, height})
        }
        reader.readAsDataURL(file)
    })
}
export async function getThumbnailAsync(file: File, time = 1000): Promise<{uri: string, width?:number, height?: number}> {
    if(!file.type?.startsWith("video")){
        return getImageThumbnail(file);
    }
    const videoFile = file as Blob | undefined;
    if (!videoFile) {
        throw new Error("File is undefined or not a Blob");
    }

    let timestamp = time / 1000;
    return new Promise((resolve, reject) => {
        // Create a hidden video element
        console.log(typeof videoFile, videoFile, videoFile instanceof File, videoFile instanceof Blob)
        const video = document.createElement('video');
        video.src = URL.createObjectURL(file)
        // video.srcObject = new Blob([videoFile], {type: file.mimeType});
        // video.src = URL.createObjectURL(videoFile);
        // video.crossOrigin = 'anonymous'; // Allow CORS for external videos

        video.onloadeddata = () => {
            // Ensure the timestamp is within the video duration
            if (timestamp > video.duration) {
                timestamp = video.duration / 2; // Default to the middle of the video
            }
            video.currentTime = timestamp;
        };

        video.onseeked = () => {
            // Create a canvas to capture the frame
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            // Draw the current video frame to the canvas
            if(!context){
                throw new Error('Failed to create canvas context');
            }
            context.drawImage(video, 0, 0, canvas.width, canvas.height);

            // Generate the thumbnail as a data URL
            const dataURL = canvas.toDataURL("image/png", 80);
            resolve({
                uri:dataURL,
                width: canvas.width,
                height: canvas.height,
            }); // Resolve the promise with the thumbnail blob

            // Clean up resources
            // video.src = '';
            video.remove();
            canvas.remove();
        };

        video.onerror = () => {
            // console.log(e.target.error)
            reject(new Error('Failed to load video'));
        };
    });
}
export function isValidUrl(url: string): boolean {
    try {
        new URL(url);
        return true;
    } catch (e) {
        return false;
    }
}

export function extractFirstURLFromCaption(caption: string){
    if(!caption) return null;
    const urls = caption.match(/(https?:\/\/[^\s]+)/g);
    const u = urls ? urls[0] : null;
    if(isValidUrl(u)){
        return u;
    }
}
